// extracted by mini-css-extract-plugin
export default {"home":"style_home__WC0qF"};